import { useQuery } from 'react-query';
import { getUserId } from '../../../helpers/jwt';
import { getFamilies } from './userprofile';

const fetch = async () => {
  const response = await getFamilies(getUserId());
  return response;
};


export const useFetchUserFamilies = () =>
  useQuery({
    queryKey: ['user-profile-families'],
    queryFn: () => fetch()
  });